import { createContext, useContext } from "react";
import type { DesktopHostModel } from "@/models/useDesktopHost";

export const DesktopHostContext = createContext<DesktopHostModel | undefined>(
  undefined,
);

export const useSharedDesktopHost = (): DesktopHostModel => {
  const host = useContext(DesktopHostContext);
  if (!host) {
    throw new Error(
      "useSharedDesktopHost must be used inside DesktopHostProvider",
    );
  }
  return host;
};
